module.exports = __webpack_public_path__ + "static/image_14-a6cabf3377f513517db901698f6b7e57.jpg";